<template>
  <div v-if="isActive">
    <FinalScreen v-if="isFinalScreen" />
    <div
      v-else
      class="waitingScreen"
      :class="{ pointer: isWaiting }"
      @click="onCancel"
    >
      <div class="waitingScreen__lady"></div>
      <div v-if="isWaiting" class="waitingScreen__money"></div>
      <div class="waitingScreen__center">
        <div v-if="isWaiting" class="waitingScreen__center__clock">
          <div class="waitingScreen__center__clock__base"></div>
          <div class="waitingScreen__center__clock__arrow"></div>
          <div class="waitingScreen__center__clock__button"></div>
        </div>
      </div>
      <div class="waitingScreen__center">
        <div class="waitingScreen__center__text">
          <div
            class="waitingScreen__center__text__firstLine"
            v-text="message.firstLine"
          />
          <div
            class="waitingScreen__center__text__secondLine"
            v-text="message.secondLine"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FinalScreen from "@/components/game/FinalScreen.vue";
import { splashScreenEnum } from "../../store/game/store";

export default {
  name: "GameSplashScreen",
  components: { FinalScreen },
  computed: {
    ...mapGetters(["activeGame", "splashScreenState"]),
    isActive() {
      return !!this.splashScreenState;
    },
    turn() {
      return this.activeGame && this.activeGame.turn;
    },
    lastRound() {
      return (
        this.activeGame && this.activeGame.turn === this.activeGame.maxTurn
      );
    },
    isWaiting() {
      return this.splashScreenState === splashScreenEnum.WAITING_FOR_NEXT_ROUND;
    },
    isFinalScreen() {
      return this.splashScreenState === splashScreenEnum.GAME_END_RESULT;
    },
    message() {
      switch (this.splashScreenState) {
        case splashScreenEnum.GAME_IS_LOADING:
          return {
            firstLine: "THE GAME",
            secondLine: "IS LOADING",
          };
        case splashScreenEnum.WAITING_FOR_NEXT_ROUND:
          if (!this.lastRound) {
            return {
              firstLine: "WAITING FOR",
              secondLine: "NEXT ROUND",
            };
          } else {
            return {
              firstLine: "WAITING FOR",
              secondLine: "GAME CONCLUSION",
            };
          }
        case splashScreenEnum.GAME_IS_COMPUTING:
          return {
            firstLine: "THE GAME",
            secondLine: "IS COMPUTING",
          };
        case splashScreenEnum.NEW_ROUND_STARTING:
          return {
            firstLine: `ROUND ${this.turn}`,
            secondLine: "IS STARTING",
          };
        case splashScreenEnum.ROUND_IS_ENDING:
          return {
            firstLine: `ROUND ${this.turn}`,
            secondLine: "IS ENDING",
          };
        case splashScreenEnum.GAME_IS_ENDING:
          return {
            firstLine: `THE GAME`,
            secondLine: "IS ENDING",
          };
        default:
          return {};
      }
    },
  },
  methods: {
    onCancel: function () {
      if (this.isWaiting) {
        this.$store.dispatch("waitForNextRound", false);
      }
    },
  },
};
</script>
